import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import TwitterIcon from '@mui/icons-material/Twitter'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import {
  Box,
  IconButton,
  Link,
  Typography,
  useMediaQuery
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import CustomButton from '../../common/button/commonButton'
import { APP_LINK, APP_LINKS2 } from '../../common/menu/menuItems/menuList'
import ReusableFormFields from '../../common/textfield/ReusableTextfield'
import {
  ImageContainer,
  LoginContainer,
  LoginStyle,
  PageContainer,
  StyledContainer
} from '../../commonStyle/loginStyle'
import Logo from '../../image/logo.png'
import wardImage1 from '../../image/wardImage1.png'
import { authResetState, loginRequest } from '../../redux/auth/authActions'
import { LoginValue } from '../../redux/value/storeAction'
import { SuccessDialog } from './loginstyle'



function LoginPage() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { success, successMessage, error, errorMessage, message } = useSelector((state) => state.auth?.user || {});
  const loginState = useSelector((state) => state.auth?.user || {});
  const loginValues = useSelector((state) => state.values?.loginValues || []);
  
  useEffect(() => {
    if (loginState && loginState.success) {
      dispatch(LoginValue(loginState));
    }
  }, [dispatch, loginState]);
  
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
 
  
  const togglePasswordVisibility = () => {
    setShowPassword(prev => !prev);
  };
  const { register, handleSubmit, formState: { errors }, setValue, setError, control } = useForm({
  defaultValues: {
    email: "adminyaa@gmail.com",
    password: "Test@12345"
  }
});
useEffect(() => {
  handleSubmit(onSubmit)();
}, []);

  const handleSuccessRedirect = useCallback(() => {
    const userInfo = loginValues[0]?.user || {};
    const userType = userInfo.user_type;
    switch (userType) {
      case 1:
        navigate(APP_LINK.DASHBOARD);
        break;
      case 3:
        navigate(APP_LINK.STAFFDASHBOARD);
        break;
      case 2:
        navigate(APP_LINKS2.DOCTORDASHBOARD);
        break;
      default:
        navigate(APP_LINK.DASHBOARD);
    }
  }, [navigate, loginValues]);

  useEffect(() => {
    if (error && errorMessage) {
      const errorLower = errorMessage.toLowerCase();
      if (errorLower.includes('email') || errorLower.includes('phone')) {
        setError('email', { type: 'manual', message: errorMessage });
      } else if (errorLower.includes('password')) {
        setError('password', { type: 'manual', message: errorMessage });
      }
    }
    dispatch(authResetState());
  }, [error, errorMessage, setError, dispatch]);

  useEffect(() => {
    if (success && successMessage) {
      setOpenSuccessDialog(true);
      const timer = setTimeout(() => {
        setOpenSuccessDialog(false);
        handleSuccessRedirect();
        dispatch(authResetState());
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [success, successMessage, handleSuccessRedirect, dispatch]);

  const handleDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleNavigate = (event) => {
    event.preventDefault();
    navigate('/');
  };

  const handleForgotPassword = (event) => {
    event.preventDefault();
    navigate(APP_LINK.FORGOTPASSWORD);
  };

  const onSubmit = (data) => {
    dispatch(loginRequest(data));
  };

  const passwordToggleIcon = (
    <IconButton
      onClick={togglePasswordVisibility}
      size="small"
      edge="end"
      aria-label="toggle password visibility"
    >
      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
    </IconButton>
  );

  const inputFields = [
    {
      name: "email",
      label: "Email Address",
      placeholder: "Enter email",
      type: "text",
      rules: { required: "Email is required" },
      size: "small",
      error: errors.email?.message,
    },
    {
      name: "password",
      label: "Password",
      placeholder: "Password",
      type: showPassword ? "text" : "password",
      rules: { required: "Password is required" },
      size: "small",
      error: errors.password?.message,
      endIcon: passwordToggleIcon
    }
  ];

  return (
    <PageContainer>
      <StyledContainer>
        <ImageContainer>
          <Box sx={LoginStyle.boxOn}>
            <Box sx={LoginStyle.boxTwo}>
              <Box
                component='img'
                src={Logo}
                alt='XRay Logo'
                sx={LoginStyle.boxThree}
              />
              <Typography
                variant='h4'
                component='h1'
                sx={LoginStyle.typographyBold}
              >
               அரசு மோகன் குமாரமங்கலம்
              </Typography>
              <Typography
                variant='h4'
                component='h1'
                sx={LoginStyle.typographyBold}
              >
               மருத்துவக் கல்லூரி மருத்துவமனை
              </Typography>
              <Typography
                variant='h4'
                component='h1'
                sx={LoginStyle.typographyBold}
              >
            சேலம் -1
              </Typography>
            </Box>
            {!isMobile && (
              <Box sx={LoginStyle.boxFore}>
                <Box
                  component='img'
                  src={wardImage1}
                  alt='Hospital facility'
                  sx={LoginStyle.boxFive}
                />
                <Typography variant='h3' sx={LoginStyle.typographyOne}>
                  " Pay Ward "
                </Typography>
              </Box>
            )}
          </Box>
        </ImageContainer>
        <LoginContainer elevation={0}>
          <Box sx={LoginStyle.boxSix}>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component='h1'
              sx={LoginStyle.typographyTwo}
            >
              Sign In
            </Typography>
            <Typography
              variant='body2'
              color='textSecondary'
              sx={LoginStyle.textSecondary}
            >
              Enter your email address and password to access the admin panel.
            </Typography>
            <form onSubmit={handleSubmit(onSubmit)}>
              <ReusableFormFields
                inputFields={inputFields}
                control={control}
                register={register}
                errors={errors}
                setValue={setValue}
                gridProps={{ sm: 12 }}
              />
              <Box sx={{
                marginTop: "10px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}>
                <Box>
                  <Link
                    onClick={handleForgotPassword}
                    sx={{ color: "#15abc0" }}
                    underline="hover"
                  >
                    Forgot Password?
                  </Link>
                </Box>
                <CustomButton
                  type='submit'
                  text='Sign In'
                  variant='contained'
                  disableElevation
                  size='small'
                  disabled={loginState?.inProgress}
                  loading={loginState?.inProgress}
                />
              </Box>
            </form>
            <Box sx={LoginStyle.footerContainer}>
              <Typography variant='body2' color='textSecondary'>
                Don't have an account?{' '}
                <Link
                  onClick={handleNavigate}
                  sx={LoginStyle.signUpLink}
                  underline="hover"
                >
                  Sign Up
                </Link>
              </Typography>
              <Box sx={LoginStyle.socialIconsContainer}>
                <IconButton size='small' sx={LoginStyle.iconButton}>
                  <FacebookIcon fontSize='small' />
                </IconButton>
                <IconButton size='small' sx={LoginStyle.iconButton}>
                  <TwitterIcon fontSize='small' />
                </IconButton>
                <IconButton size='small' sx={LoginStyle.iconButton}>
                  <InstagramIcon fontSize='small' />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </LoginContainer>
      </StyledContainer>

      {/* Material UI Success Dialog */}
      <SuccessDialog open={openSuccessDialog} onClose={handleDialogClose} />
    </PageContainer>
  );
}

export default LoginPage;


